































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  getClass,
  checkMember,
  addStudent,
  removestudent
} from '@/api/class/class'
import YKDClass, { YKDClassStudent } from '@/model/class/class'
import { State, Action, namespace } from 'vuex-class'
import { Account, fetchAccountWithoutRedirect } from 'ykd-base/account'
import { YKDCenterDrawer, YKDRightDrawer } from 'gum-ui'
import { message, Popconfirm, Skeleton, DatePicker } from 'ant-design-vue'
import { account } from '../../../../store/modules/account'
import { getMyLearn } from '@/api/course/course'

const ClassStore = namespace('app-ice/ykdClass')
@Component({
  components: {
    YKDRightDrawer,
    YKDCenterDrawer,
    'a-popconfirm': Popconfirm
  }
})
export default class RsManager extends Vue {
  @ClassStore.State('current') current!: YKDClass
  @ClassStore.State('currentChangeEvent') currentChangeEvent!: number
  @ClassStore.Action('removeStudent') removeStudent!: Function
  @ClassStore.Action('addStudents') addStudents!: Function

  private students: YKDClassStudent[] = []
  private tableLoading: boolean = false
  private studentDates: YKDClassStudent[] = []
  private centerDrawer: boolean = false
  private mobile: string = ''
  private accountList: Account[] = []
  private checkedIds: string[] = []
  private loading: boolean = false
  private inputLoading: boolean = false
  private rightDrawer: boolean = false
  private studentMobile: string = ''
  private studentDetailDatas: any[] = []
  private studentDetailTableLoading: boolean = false

  onTabChange(key: string) {
    console.log(key)
  }

  closeRight() {
    this.studentDetailTableLoading = false
    this.rightDrawer = false
    this.studentDetailDatas = []
  }

  private studentDetailColumns: any = [
    {
      title: '课程名',
      dataIndex: 'title',
      key: 'title'
    },
    {
      title: '课程 id',
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: '进度',
      key: 'process',
      dataIndex: 'myCourse.process'
    }
  ]

  async openDetail(record: YKDClassStudent) {
    let mobile = this.studentMobile || ''
    if (
      record &&
      record.account &&
      record.account.user &&
      record.account.user.mobile
    ) {
      mobile = record.account.user.mobile
    }
    this.studentDetailTableLoading = true
    this.rightDrawer = true
    const studentMyLearn = await getMyLearn(mobile)
    if (studentMyLearn) {
      this.studentDetailDatas = studentMyLearn.courses
      this.studentDetailTableLoading = false
    } else {
      setTimeout(() => {
        this.studentDetailTableLoading = false
      }, 3000)
    }
  }

  getTableDate() {
    this.studentDates = []
    if (!this.current.students || !this.current.classTeacher) {
      return
    }
    const students = this.current.students
    if (students && students.length > 0) {
      students.forEach(student => {
        let studentDate: YKDClassStudent = {}
        let name = ''
        let days = 0

        if (student.account) {
          name = student.account.accountName
            ? student.account.accountName
            : student.account.user.name
            ? student.account.user.name
            : student.account.user.nickName || ''
        }

        if (student.memberStartTime) {
          let memberStartTime = new Date(student.memberStartTime)
          days = Math.ceil(
            (new Date().getTime() - memberStartTime.getTime()) /
              (1000 * 60 * 60 * 24)
          )
        }
        studentDate = {
          account: student.account,
          days: days,
          name: name
        }
        this.studentDates.push(studentDate)
      })
    }
  }

  @Watch('current')
  currentClassChange() {
    this.getTableDate()
  }

  // @Watch('current.classTeacher')
  // @Watch('currentChangeEvent')
  // async classTeacherChange() {
  //   console.log(1222)

  //   let account = await fetchAccountWithoutRedirect()
  //   this.tableLoading = true
  //   if (this.current.classTeacher && this.current.classTeacher.id) {
  //     if (account.id === this.current.classTeacher.id) {
  //       this.deleteOperation = true
  //     }
  //     this.tableLoading = false
  //   }
  // }

  mounted() {
    this.getTableDate()
  }

  private columns: any = [
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      scopedSlots: { customRender: 'name' }
    },
    {
      title: '手机号',
      dataIndex: 'account.user.mobile',
      key: 'mobile'
    },
    {
      title: '学校',
      key: 'school',
      dataIndex: 'account.profile.schoolName'
    },
    {
      title: '专业',
      key: 'project',
      dataIndex: 'account.profile.major'
    },
    {
      title: '会员天数',
      key: 'days',
      dataIndex: 'days',
      sorter: (a: any, b: any) => a.days - b.days
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' }
    }
  ]

  async remove(record: any) {
    let account = await fetchAccountWithoutRedirect()
    if (this.current.classTeacher && this.current.classTeacher.id) {
      if (account.id != this.current.classTeacher.id) {
        message.error('只有本班的班主任可以移除学生哦')
        return
      }
    }
    const result = await removestudent(record.account.id, this.current.id)
    if (result.isSuccess) {
      message.success('移除成功')
      await this.removeStudent(record.account.id)
      this.getTableDate()
    } else {
      message.error('移除失败')
    }
  }

  closeCenter() {
    this.checkedIds = []
    this.accountList = []
    this.mobile = ''
    this.centerDrawer = false
  }

  openDrawer() {
    this.centerDrawer = true
  }

  async memberSearch(e: any) {
    this.inputLoading = true
    const result = await checkMember(e, this.current.id)
    this.inputLoading = false

    if (this.accountList && this.accountList.length > 4) {
      message.warning('最后同时展示五个用户')
    }

    if (result.code === '2000' || result.code === '4030') {
      let accountIds = this.accountList.map(account => account.id)
      if (accountIds.indexOf(result.data.id) > -1) {
        message.error('无法重复添加同一用户')
        return
      }

      if (result.code === '4030') {
        message.warn('用户没有购买对应的商品')
      }

      this.accountList.push(result.data)
      this.checkedIds.push(result.data.id)
    } else if (result.code === '4040') {
      message.warning('未查询到用户')
    } else if (result.code === '5050') {
      message.warning('学生无法重复添加到同一班级')
    } else {
      message.error('查询失败')
    }
  }

  checkedHandler(accountId: string) {
    let index = this.checkedIds.indexOf(accountId)
    if (index > -1) {
      this.checkedIds.splice(index, 1)
    } else {
      const checkedIds: string[] = this.checkedIds.slice(0)
      const allIds: string[] = this.accountList.map(account => account.id)
      checkedIds.push(accountId)
      this.checkedIds = []

      checkedIds.forEach(checkedId => {
        if (allIds.indexOf(checkedId) > -1) {
          this.checkedIds.push(checkedId)
        }
      })
    }
  }

  async submit() {
    if (this.checkedIds.length < 1) {
      message.warning('请选择学员')
      return
    }
    this.loading = true
    const result = await addStudent(this.checkedIds, this.current.id)
    this.loading = false

    if (result.isSuccess) {
      message.success('添加成功')
      this.addStudents(result.data)
      this.closeCenter()
      this.getTableDate()
    } else {
      message.error('添加失败')
    }
  }
}
